import type { Icon } from '../../../src/lib/types'
export const mdiCheck: Icon = {
  "id": "check",
  "name": "Check",
  "path": "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z",
  "as": [
    "tick",
    "done"
  ],
  "tags": []
}
export default mdiCheck